<template>
    <div
        id="offer-details-popin"
        ref="offerDetailsPopin"
        aria-labelledby="offer-details-popin"
        class="modal fade pt-popin-cds"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        data-ob1-component="Popin"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content pb-0 px-1 px-md-2">
                <div>
                    <!--/* header */-->
                    <div class="modal-header">
                        <Lien
                            v-if="activeView !== 'offer-content'"
                            id="back-button"
                            :is-button="true"
                            :is-mini="true"
                            :is-link-arrow-back="true"
                            :label="'Retour'"
                            @click="goBack"
                        />
                        <button
                            type="button"
                            class="btn-close pt-2 pt-md-0"
                            data-bs-dismiss="modal"
                            aria-label="Fermer"
                            style="display: block !important"
                        >
                            <span class="icon icon-delete" aria-hidden="true" />
                        </button>
                        <button
                            type="button"
                            class="btn-close ob1-link-arrow back"
                            data-bs-dismiss="modal"
                            style="display: none !important"
                        >
                            Fermer
                        </button>
                    </div>
                    <!--/* content */-->
                    <div class="modal-body px-0">
                        <div v-if="activeView === 'offer-content'" class="row">
                            <!-- Titre popin -->
                            <div class="col-12 px-2 px-md-3 px-lg-5">
                                <div class="h4 mb-0">
                                    {{ dto.title }}
                                </div>
                            </div>

                            <!-- Onglets forfaits mobiles -->
                            <div class="col-12 px-2 px-md-3 px-lg-5">
                                <nav class="ob1-menu-page" style="height: auto !important;">
                                    <ul class="nav ob1-nav-light">
                                        <li
                                            v-for="(item, itemIndex) in dto.items"
                                            :key="(item && item.name) ? item.name : `CrossSellOffer-${itemIndex}`"
                                            class="nav-item"
                                            :class="{ active: item.seoId === selectedOffer.seoId }"
                                        >
                                            <button
                                                class="nav-link px-0"
                                                data-oevent-category="offer_details_popin"
                                                :data-oevent-action="getActionTms(item.secondaryShortLabel)"
                                                :data-oevent-label="item.seoId"
                                                @click="changeSelectedTab(item)"
                                                v-text="item.secondaryShortLabel"
                                            />
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                            <!-- Détail du forfait sélectionné -->
                            <div class="col-12">
                                <div class="row">
                                    <div class="my-1 col-12 px-2 px-md-3 px-lg-5">
                                        <!--/* header offre */-->
                                        <div class="row">
                                            <div class="col-10">
                                                <strong
                                                    v-if="showBanner(selectedOffer.banner)"
                                                    v-msh-html="selectedOffer.banner"
                                                    class="ob1-tag ob1-tag-primary mb-1"
                                                />
                                                <h2 class="visually-hidden">
                                                    {{ nameAccessibility(selectedOffer) }}
                                                </h2>
                                                <p class="fw-bold py-0 mb-0" aria-hidden="true">
                                                    {{ selectedOffer.offerType }}
                                                </p>
                                                <h2 class="h1 py-0 mb-0" aria-hidden="true">
                                                    {{ selectedOffer.secondaryShortLabel }}
                                                </h2>
                                            </div>
                                            <div class="col-2 d-flex justify-content-end">
                                                <img
                                                    v-if="selectedOffer.showPicto5G"
                                                    :src="selectedOffer.picto5gSrc"
                                                    alt="logo 5G Orange"
                                                    class="logo-5g-popin"
                                                    aria-hidden="true"
                                                >
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-12">
                                                <div :class="showOpenDiscountMessage ? 'my-1 px-1 bg-greige' : 'mt-1 mb-0'">
                                                    <template v-if="showOpenDiscountMessage">
                                                        <div
                                                            class="fw-bold small text-dark pt-1 pb-0 pe-1"
                                                            v-html="selectedOffer.openDiscountMessage"
                                                        />
                                                    </template>
                                                    <PriceWithDetails
                                                        class="price-align"
                                                        :price="selectedOffer.price"
                                                        :price-details-popin="selectedOffer.priceDetailsPopin ?? undefined"
                                                        :offer-id-seo="selectedOffer.seoId"
                                                        :offer-name="selectedOffer.name"
                                                        tracking-category="offer_details_popin"
                                                        :is-black="false"
                                                        :is-embedded-details="true"
                                                        @show-details="showPriceDetails"
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                v-if="selectedOffer.monthlyOdrs && !selectedOffer.priceDetailsPopin"
                                                class="col-12"
                                            >
                                                <ul class="row list-unstyled mb-0" aria-label="Offres de réductions mensuelles du forfait">
                                                    <li v-for="(odr, index) in selectedOffer.monthlyOdrs" :key="index">
                                                        <InlinePromise :claim="{ attributes: { textHtml: odr } }" :is-warning="true" :compact-text="true" />
                                                    </li>
                                                </ul>
                                            </div>
                                            <div
                                                v-if="selectedOffer.claims && selectedOffer.claims.length > 0"
                                                :class="selectedOffer.priceDetailsPopin ? 'col-12 pt-1' : 'col-12'"
                                            >
                                                <ul class="row list-unstyled mb-0" aria-label="Avantages du forfait">
                                                    <li v-for="(claim, index) in selectedOffer.claims">
                                                        <InlinePromise :key="`claim-${index}`" :claim="claim" />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <!--/* attributs accordion */-->
                                        <div class="row mb-4">
                                            <div class="col-12">
                                                <div class="accordion" itemscope="" itemtype="https://schema.org/FAQPage">
                                                    <div
                                                        v-for="(detailAttribute, attributeIndex) in (selectedOffer.detailAttributes || [])"
                                                        :key="`${selectedOffer.idSeo}-${attributeIndex}`"
                                                        class="card multi"
                                                        itemscope=""
                                                        itemprop="mainEntity"
                                                        itemtype="https://schema.org/Question"
                                                    >
                                                        <div class="card-header">
                                                            <button
                                                                :id="`faqQuestion-${selectedOffer.idSeo}-${attributeIndex}`"
                                                                class="collapsed"
                                                                data-bs-toggle="collapse"
                                                                :data-bs-target="`#faqAnswer-${selectedOffer.idSeo}-${attributeIndex}`"
                                                                :aria-controls="`faqAnswer-${selectedOffer.idSeo}-${attributeIndex}`"
                                                                aria-expanded="false"
                                                                type="button"
                                                            >
                                                                <div class="accordion-card-title">
                                                                    <p class="accordion-title mb-0" itemprop="name">
                                                                        <span>{{ detailAttribute.titleAttribute }}</span>
                                                                    </p>
                                                                    <p class="accordion-icon mb-0" aria-hidden="true" />
                                                                </div>
                                                            </button>
                                                        </div>
                                                        <div
                                                            :id="`faqAnswer-${selectedOffer.idSeo}-${attributeIndex}`"
                                                            class="collapse"
                                                            :aria-labelledby="`faqQuestion-${selectedOffer.idSeo}-${attributeIndex}`"
                                                            role="region"
                                                            itemscope
                                                            itemprop="acceptedAnswer"
                                                            itemtype="https://schema.org/Answer"
                                                        >
                                                            <div class="accordion-card-body standard" itemprop="text" v-html="detailAttribute.textAttribute" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!--/* Mentions légales  */-->
                                        <div v-if="selectedOffer.legalMentions" class="pb-2">
                                            <ob1-liens-haut-bas
                                                :button-id="selectedOffer.legalMentions.title.headerId"
                                                :button-label="selectedOffer.legalMentions.title.title"
                                                :collapsed-block-id="selectedOffer.idSeo + '-' + selectedOffer.legalMentions.title.textId"
                                            >
                                                <div v-for="(mention, index) in selectedOffer.legalMentions.mentions" :key="'mentiontext-' + selectedOffer.idSeo + '-' + index">
                                                    <strong v-if="mention.title">{{ mention.title }}</strong>
                                                    <span v-if="mention.text" v-html="mention.text" />
                                                </div>
                                            </ob1-liens-haut-bas>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--/* DETAILS du prix de l'offre */-->
                        <div v-if="activeView === 'price-content'" class="row">
                            <div class="col-12 px-2 px-md-3 px-lg-5">
                                <PriceDetailsContent
                                    :id="selectedOffer.seoId"
                                    :offer-type="selectedOffer.offerType"
                                    :offer-name="selectedOffer.secondaryShortLabel"
                                    :offer-price="selectedOffer.price"
                                    :price-details="selectedOffer.priceDetailsPopin"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="sticky-bottom py-2 bg-white modal-footer d-flex justify-content-center">
                        <button
                            class="btn btn-primary px-3"
                            style="padding-left: 0; padding-right: 0;"
                            type="button"
                            :data-oevent-category="selectedOffer.selectButtonTms.category"
                            :data-oevent-action="selectedOffer.selectButtonTms.action"
                            :data-oevent-label="selectedOffer.selectButtonTms.label"
                            @click="addMobileOfferInCart(selectedOffer.seoId, selectedOffer)"
                            v-text="selectedOffer.selectButtonLabel"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InlinePromise from "../../components/ob1/InlinePromise.vue";
import PriceWithDetails from "../../components/custom/PriceWithDetails.vue";
import PriceDetailsContent from "../../../fmfmo/acquisition/vitrine/fragments/PriceDetailsContent.vue";
import Lien from "../../components/ob1/Lien.vue";

export default {
    name: 'CartPageCrossSellContent',
    components: {
        Lien,
        PriceDetailsContent,
        PriceWithDetails,
        InlinePromise,
    },
    props: {
        dto: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            activeView: 'offer-content',
            selectedOffer: this.dto.items[0]
        }
    },
    computed: {
        showOpenDiscountMessage() {
            return this.selectedOffer?.openDiscountMessage !== undefined
                && (this.selectedOffer?.priceDetailsPopin === undefined || this.selectedOffer?.priceDetailsPopin === null)
        },
    },
    mounted() {
        const modalElement = document.getElementById('offer-details-popin');
        if (modalElement) {
            modalElement.addEventListener('hidden.bs.modal', this.onModalHidden);
        }
    },
    beforeDestroy() {
        const modalElement = document.getElementById('offer-details-popin');
        if (modalElement) {
            modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden);
        }
    },
    methods: {
        changeSelectedTab(offer) {
            if (offer !== "") {
                this.selectedOffer = offer;
            }
        },
        addMobileOfferInCart(event, _crossSellItem) {
            const actionUrl = this.dto.addOfferInCartUrl;
            const actionJsonFormParams = {
                id: event,
                deviceEan: undefined,
                universe: "MOBILE",
            };
            this.addMobileOfferInProgress();
            const addMobileOfferErrorsHandler = this.addMobileOfferErrorsHandler();
            const addMobileOfferSuccessHandler = this.addMobileOfferSuccessHandler();
            $.ajax({
                method: "POST",
                url: actionUrl,
                contentType: "application/json",
                data: JSON.stringify(actionJsonFormParams)
            })
                .done(addMobileOfferSuccessHandler)
                .fail(addMobileOfferErrorsHandler);
            return false;
        },
        addMobileOfferInProgress() {
            this.$emit('add-mobile-offer-in-progress')
        },
        addMobileOfferSuccessHandler() {
            return (response) => {
                this.closeModal();
                this.$emit('add-mobile-offer-success', response);
            }
        },
        addMobileOfferErrorsHandler() {
            return (error) => {
                this.closeModal();
                this.$emit('add-mobile-offer-error', error);
            }
        },
        closeModal() {
            const modal = this.$refs.offerDetailsPopin;
            if (modal) {
                // Simuler un clic sur le bouton de fermeture qui a l'attribut data-bs-dismiss="modal"
                const closeButton = modal.querySelector('[data-bs-dismiss="modal"]');
                if (closeButton) {
                    closeButton.click();
                }
            }
        },
        nameAccessibility(offer) {
            const label5GAccessibility = offer.showPicto5G ? '5G' : '';
            const brandAccessibility = offer.brand === 'ORANGE' ? 'Forfait Orange' : 'Forfait Sosh';

            const secondaryShortLabelAccessibility = offer.secondaryShortLabel
                ? offer.secondaryShortLabel
                    .replace(/Mo/g, ' méga Octet')
                    .replace(/Go/g, ' giga Octet')
                : '';

            return brandAccessibility + ' ' + offer.offerType + ' ' + secondaryShortLabelAccessibility + ' ' + label5GAccessibility;
        },
        showBanner(banner) {
            return banner && banner !== '';
        },
        goBack() {
            if (this.activeView === 'price-content') {
                this.activeView = 'offer-content';
            }
        },
        showPriceDetails() {
            this.activeView = 'price-content';
        },
        onModalHidden() {
            this.activeView = 'offer-content';
        },
        getActionTms(label) {
            return toBroadbandTmsFormat(label);
        },
    }
}
</script>

<style scoped lang="scss">
@media (max-width: 767px) {
    .pt-popin-cds {
        padding-top: 110px !important;
    }
}
.btn-close::before {
    display: none !important;
}
.modal-dialog .modal-header {
    position: inherit !important;
}
.modal-dialog .modal-header.box-shadow {
    box-shadow: none !important;
}

.logo-5g-popin {
    position: relative;
    height: 50px;
}

//Une classe ajoutée provisoir pour la partie promo du forfait
.ob1-price .ob1-price-promo-duration {
    display: inline;
}

// correctif accordion border dernier element
.accordion .card.multi:last-child .card-header button {
    border-bottom: 0;
}
.accordion .card.multi:last-child {
    border-bottom: 1px solid #ccc;
}
</style>
